module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Medium-WebM-6a3a35b5c0bc7d99642c0d077c326e92.woff2";